export const checkForInaccurateSetId = (stock_code: string) => {
  const onlyNumbers = /[0-9]+/g

  const match = stock_code.match(onlyNumbers)

  if (match) {
    const numericValues = match[0]
    const size = numericValues.substring(numericValues.length - 2)

    if (numericValues.length < 5) {
      return 'Set id or size is wrong'
    }

    if (size !== '00') {
      return 'Products can not have size other than 00 in stock_code'
    }
  }

  return null
}
